import { useChartDisplay } from '../../../../ui-components/data-viz-ui/charts/common/common-chart-utils/use-chart-display-reducer';
import { ComponentStateManager } from '../../../common/types';
import { MultiMetricComparisonVizExternalProps } from '../../types';
import {
  MultiMetricComparisonBarChartActions,
  MultiMetricComparisonBarChartState,
} from './types';

export const useMultiMetricComparisonBarChartStateManager = (
  externalProps: MultiMetricComparisonVizExternalProps,
  persistenceKey: string
): ComponentStateManager<
  MultiMetricComparisonBarChartState,
  MultiMetricComparisonBarChartActions
> => {
  const { displayState, displayActions } = useChartDisplay(
    {
      // No percentage or stacking for multi-metric comparison
      // since each bar represents a different metric
      enablePercentage: false,
      enableStack: false,
      enableLabels: true,
      enableLegend: false, // No legend needed since each bar is labeled
      enableSortOrder: false, // Disabled - order determined by config
      enableTableView: true,
      globalDisplayState: externalProps.displayGlobalState,
    },
    persistenceKey
  );

  return {
    state: {
      displayState,
    },
    actions: {
      displayActions: {
        onClickLabels: displayActions.onClickLabels,
        onClickLegend: displayActions.onClickLegend,
        onSelectSortOrder: displayActions.onSelectSortOrder,
        onClickTableView: displayActions.onClickTableView,
        onClickWrappedXAxisLabels: displayActions.onClickWrappedXAxisLabels,
      },
    },
  };
};
